<script lang="ts">
  import { Content } from '@smui/card';
  import Dialog from '@smui/dialog';
  import 'bootstrap/js/dist/modal';
  import { getAppConfig } from '../../../common/config/app-config';
  import Icon from '../../common/components/Icon.svelte';
  import Text from '../../common/components/Text.svelte';
  import { openServicesInfoPopup, servicesInfo } from '../store/pdp_store';
  import PdpServiceExtraCareTabs from './PDPServiceExtraCareTabs.svelte';

  export let open;
  export let exploreContentList;

  const { encodedContextPath } = getAppConfig();

  function closeHandler(_e: CustomEvent<{ action: string }>) {
    $openServicesInfoPopup = false;
    open = false;
    $servicesInfo = null;
  }
  function closePopup() {
    $openServicesInfoPopup = false;
    open = false;
    $servicesInfo = null;
    document.getElementsByTagName('html')[0].style.overflow = '';
    document.getElementsByTagName('body')[0].classList.remove('mdc-dialog-scroll-lock');
  }
</script>

<div>
  <Dialog
    bind:open
    fullscreen
    aria-labelledby="fullscreen-title"
    surface$style="width:100vw;height:100dvh;max-height:100vh"
    aria-describedby="fullscreen-content"
    on:SMUIDialog:closed={closeHandler}
    class="extraDrawer-container"
  >
    <Content
      id="fullscreen-content"
      on:mouseenter={() => {
        document.getElementsByTagName('html')[0].style.overflow = 'hidden';
      }}
      on:mouseleave={() => {
        document.getElementsByTagName('html')[0].style.overflow = 'scroll';
      }}
    >
      <section class="services-info-content">
        <div class="dialog-header">
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <div class="close-btn" on:click={() => closePopup()}>
            <Icon type="font" glyph="close" mobileSize={20} desktopSize={24} />
          </div>
        </div>
        {#each exploreContentList as data, i}
          {#if data?.exploreType === 'EXPLORE_ALL_PERKS' && i === 0}
            <div id="servicesInfoModalLabel" class="dialog-title">
              <Text key="extra.vas.explore.popup.header" />
            </div>
          {/if}
          <div class="title">
            <img
              class={data?.serviceType === 'EXTRA_CARE' ? 'logoExtraCare' : 'logo'}
              src={data?.logoUrl}
              alt={data?.serviceType}
            />
            {#if data?.title?.length > 0}
              <h3>{data?.title}</h3>
            {/if}
          </div>
          <div class="sub-title">{@html data?.subText}</div>
          <div class="explore-more-link">
            <a href={`${encodedContextPath + data?.redirectUrl}`} target="_blank" rel="nofollow noopener noreferrer">
              {#if data?.exploreType === 'WHATS_INCLUDED'}
                <Text key="extra.vas.explore.popup.read.terms.text" />
              {:else}
                <Text key="extra.vas.explore.popup.more.perks" />
              {/if}
            </a>
          </div>
          {#if data?.tabDisplay === true}
            <PdpServiceExtraCareTabs keyFeatures={data?.keyFeatures} />
          {:else}
            {#if data?.exploreType === 'WHATS_INCLUDED'}
              <div class="what-included-text"><Text key="extra.vas.explore.popup.whats.included.text" /></div>
            {/if}
            {#each data?.keyFeatures as keyFeatures}
              <div class="services-info-list">
                {#if keyFeatures.title !== null}
                  <h3 class="services-info-title">{keyFeatures?.title}</h3>
                {/if}
                <ul>
                  {#each keyFeatures?.features as feature}
                    <li>{feature}</li>
                  {/each}
                </ul>
              </div>
            {/each}
          {/if}
        {/each}
      </section>
    </Content>
  </Dialog>
</div>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  :global {
    html:has(.mdc-dialog--open) {
      overflow: hidden !important;
    }
    .extraDrawer-container {
      .mdc-dialog__container {
        justify-content: flex-end !important;
        z-index: 10000;
        height: 100dvh;
        .mdc-dialog__content {
          // max-height: calc(100% - 145px);
          overflow-y: auto;
          scrollbar-width: none; /* Also needed to disable scrollbar Firefox */
          padding: 0 !important;
          &::-webkit-scrollbar {
            display: none;
          }
        }
        .mdc-dialog__actions {
          background-color: $primary-white;
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
        }

        .mdc-dialog__surface {
          width: 655px !important;
          min-height: 100% !important;
          min-width: unset;

          .services-info-content {
            padding: 0px;
            @include desktop-min-width {
              padding: 70px 42px;
              text-align: initial;
            }
            .close-button {
              display: flex;
              text-align: end;
              justify-content: end;
            }
            .dialog-title {
              font-size: 20px;
              line-height: 22px;
              font-weight: 700;
              margin: 15px 0;
              color: $neutral-dark-01;
              @include desktop-min-width {
                font-size: 26px;
                line-height: 28px;
              }
            }
            .title {
              .logo {
                margin-top: 20px;
                width: 171px;
              }
              .logoExtraCare {
                margin-top: 20px;
                width: 102px;
              }
              h3 {
                font-size: 20px;
                line-height: 22px;
                font-weight: 700;
                margin: 30px 0 15px;
                color: $neutral-dark-01;
                @include desktop-min-width {
                  font-size: 24px;
                  line-height: 28px;
                }
              }
            }
            .sub-title {
              font-size: 14px;
              line-height: 16px;
              font-weight: 400;
              margin: 12px 0;
              color: $neutral-dark-03;
              line-height: 20px;
              @include desktop-min-width {
                font-size: 16px;
                line-height: 22px;
              }
            }
            .explore-more-link {
              margin: 10px 0 20px;
              a {
                font-size: 14px;
                line-height: 16px;
                font-weight: 500;
                color: $icon-only-icon-blue-01;
                outline: none;
                @include desktop-min-width {
                  font-size: 16px;
                  line-height: 18px;
                }
              }
            }
            .services-info-list {
              border: 2px solid $secondary-gray-02;
              border-radius: 8px;
              margin-bottom: 20px;
              .services-info-title {
                font-size: 16px;
                font-weight: 500;
                line-height: 18px;
                color: $neutral-dark-01;
                padding: 0 15px;
                @include desktop-min-width {
                  font-size: 18px;
                  line-height: 18px;
                }
              }
              ul {
                list-style: none;
                margin: 0;
                li::before {
                  content: '• ';
                  padding-right: 4px;
                }
                li {
                  padding: 16px 20px;
                  font-size: 14px;
                  font-weight: 400;
                  line-height: 16px;
                  border-bottom: 1px solid $secondary-gray-02;
                  display: flex;
                  gap: 4px;
                }
                li:last-child {
                  border-bottom: 0;
                }
              }
            }
            .what-included-text {
              font-size: 20px;
              line-height: 22px;
              font-weight: 700;
              padding: 20px 0;
              margin-top: 20px;
              color: $neutral-dark-01;
              border-top: 1px solid $secondary-gray-02;
              @include desktop-min-width {
                font-size: 24px;
                line-height: 28px;
              }
            }
          }
        }
      }
    }
    .extraDrawer-container {
      z-index: 10000 !important;
      justify-content: flex-end !important;
      .atc-qac-delivery-detail {
        padding: 0 48px 24px;
        @include responsive {
          padding: 0 0.8rem 0.8rem;
        }
      }
    }
  }
</style>
